// extracted by mini-css-extract-plugin
module.exports = {"voiceControlsContainer":"VoiceControlsContainer_voiceControlsContainer__2fCHI"};